/** Collect a complete cursor-paginated listing, failing on an invalid cursor. */
export async function collectPages<T>(
  fetchPage: (cursor: string | undefined) => Promise<{
    data: T[];
    pagination: { hasMore: boolean; cursor?: string };
  }>,
): Promise<T[]> {
  const items: T[] = [];
  const seen = new Set<string>();
  let cursor: string | undefined;
  let hasMore = true;
  while (hasMore) {
    const page = await fetchPage(cursor);
    items.push(...page.data);
    hasMore = page.pagination.hasMore;
    if (!hasMore) break;
    cursor = page.pagination.cursor;
    if (!cursor || seen.has(cursor)) throw new Error('Paginación incompleta');
    seen.add(cursor);
  }
  return items;
}
